export const MedicationsFormFamily = {
  title: 'Medications',
  formVersion: 1,
  description: 'Client Medications Intake Form',
  formKey: 'CLIENT_MEDICATIONS_INTAKE_FORM',
  questions: {
    'Medications-help': {
      questionId: 'Medications-help',
      fieldType: 'checkbox',
      rank: 1,
      questionData: {
        label: 'What type of medication help do they need?',
        helpText: '',
        required: true,
      },
      options: [
        {value: 'reminders', label: 'Reminders to take medications', isOther: false},
        {value: 'opening', label: 'Assistance opening bottles or packaging', isOther: false},
        {value: 'organizing', label: 'Assistance organizing pills in a weekly pillbox', isOther: false},
        {value: 'bringing', label: 'Help bringing medications to them', isOther: false},
        {value: 'monitoring', label: 'Monitoring that medications were taken', isOther: false},
        {value: 'timing', label: 'Prompting for timing (morning / evening / with food)', isOther: false},
        {value: 'other', label: 'Other', isOther: true},
      ],
    },
    'Medications-related-tasks': {
      questionId: 'Medications-related-tasks',
      fieldType: 'checkbox',
      rank: 2,
      questionData: {
        label: 'Do they need help managing related tasks?',
        helpText: '',
        required: true,
      },
      options: [
        {value: 'refills', label: 'Keeping track of refills', isOther: false},
        {value: 'recording', label: 'Recording when doses were taken', isOther: false},
        {value: 'coordinating', label: 'Coordinating with family about changes', isOther: false},
        {value: 'side-effects', label: 'Watching for side effects', isOther: false},
        {value: 'storage', label: 'Ensuring medications are stored safely', isOther: false},
        {value: 'other', label: 'Other', isOther: true},
      ],
    },
    'Medications-routine': {
      questionId: 'Medications-routine',
      fieldType: 'radio',
      rank: 3,
      questionData: {
        label: 'How would you describe their medication routine?',
        helpText: '',
        required: true,
      },
      options: [
        {value: 'simple', label: 'Very simple (same meds, same time each day)', isOther: false},
        {value: 'varied', label: 'A bit varied (a few meds at different times)', isOther: false},
        {value: 'complex', label: 'Many steps (several meds or multiple times a day)', isOther: false},
        {value: 'as-needed', label: 'Only taken when needed', isOther: false},
        {value: 'other', label: 'Other', isOther: true},
      ],
    },
  },
};
